// src/components/DashboardLayout.jsx
import styled from 'styled-components';
import Sidebar from './Navbar';

const Layout = styled.div`
  display: flex;
  width: 100vw;        /* toute la largeur de la fenêtre */
  height: 100vh;       /* toute la hauteur de la fenêtre */
`;

const SidebarArea = styled.div` grid-area: sidebar; `;

export const MainContent = styled.main`
width: 100%`;

const Footer = styled.footer`
  grid-area: footer;
  background-color: ${({ theme }) => theme.colors.surface};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
`;

export default function DashboardLayout({ children }) {
  return (
      <Layout>
        <SidebarArea>
          <Sidebar />
        </SidebarArea>

        <MainContent>
          {children}
        </MainContent>
      </Layout>
  );
}
